export const moduleConfig = {
  module: {
    title: 'Library',
    description: 'Email templates and reference documents',
    i18nKey: 'email-library',
    route: {
      list: '/library',
    },
  },
};
